<template>
    <div class="content">
        <mainCardsRow></mainCardsRow>
        <chartsRow></chartsRow>
    </div>
</template>
<script>
import mainCardsRow from './components/mainCardsRow.vue';
import chartsRow from './components/chartsRow.vue';
export default {
    components:{
        mainCardsRow,
        chartsRow
    }
}
</script>